import React from "react";
import { SnackbarProvider } from "notistack";
import Routes from "./Routes";
import RTUThemeProvider from "./RTUThemeProvider";
import TokenRenewer from "./features/TokenRenewer";

function App() {
  return (
    <>
      <RTUThemeProvider>
        <SnackbarProvider>
          <Routes />
        </SnackbarProvider>
      </RTUThemeProvider>

      {/* APP Listeners */}
      <TokenRenewer />
    </>
  );
}

export default App;
